export type NotificationEventType = "AddedToPrintQueue" | string;

const notificationEventTypeLookup: {
  [key: NotificationEventType]: "addedToPrintQueue";
} = {
  AddedToPrintQueue: "addedToPrintQueue",
};

export const notificationEventTypeToName = (id: string) => {
  return notificationEventTypeLookup[id];
};
